<script lang="ts">
	import heroImage3Xl from "@assets/images/about.jpg?webp&imagetools";
	import heroImageXs from "@assets/images/about.jpg?webp&w=960&h=1000&imagetools";
	import heroImageSm from "@assets/images/about.jpg?webp&w=1280&h=1000&imagetools";
	import heroImageMd from "@assets/images/about.jpg?webp&w=1600&imagetools";
	import heroImageLg from "@assets/images/about.jpg?webp&w=1920&imagetools";
	import heroImageXl from "@assets/images/about.jpg?webp&w=1920&imagetools";
	import heroImage2Xl from "@assets/images/about.jpg?webp&w=2400&imagetools";
	import coursesLogoCs from "@assets/images/courses-logo-cs.png?webp&w=287&imagetools";
	import coursesLogoEn from "@assets/images/courses-logo-en.png?webp&w=287&imagetools";
	import fathersFamilyLogo from "@assets/images/fathers-family-written.png?webp&w=640&imagetools";
	import coursesImage3Xl from "@assets/images/homepage-courses.jpg?webp&imagetools";
	import coursesImageXs from "@assets/images/homepage-courses.jpg?webp&w=960&h=1000&imagetools";
	import coursesImageSm from "@assets/images/homepage-courses.jpg?webp&w=1280&h=1000&imagetools";
	import coursesImageMd from "@assets/images/homepage-courses.jpg?webp&w=1600&imagetools";
	import coursesImageLg from "@assets/images/homepage-courses.jpg?webp&w=1920&imagetools";
	import coursesImageXl from "@assets/images/homepage-courses.jpg?webp&w=1920&imagetools";
	import coursesImage2Xl from "@assets/images/homepage-courses.jpg?webp&w=2400&imagetools";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import HandwrittenBanner from "@components/sections/HandwrittenBanner.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { Locale } from "@core/schema/Locale.js";
	import { getCoursesListingPath } from "@core/schema/paths/getCoursesListingPath.js";
	import { getMembershipPagePath } from "@core/schema/paths/getMembershipPagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./CoursesAndFamilySection.translations.json" with { type: "json" };

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
	const coursesLogo = tenant.locale === Locale.cs ? coursesLogoCs : coursesLogoEn;
</script>

<div class="grid lg:!grid-cols-2 full-width">
	<HandwrittenBanner
		topAligned
		title={translate("courses")}
		tagline={translate("coursesList")}
		lettering={{ src: coursesLogo, width: 314, height: 225 }}
		media="object-[0%_51%]"
		sources={{
			default: coursesImageXs,
			">sm": coursesImageSm,
			">md": coursesImageMd,
			">lg": coursesImageLg,
			">xl": coursesImageXl,
			">2xl": coursesImage2Xl,
			">3xl": coursesImage3Xl,
		}}
	>
		{#snippet actions()}
			<Link size={ButtonSize.Medium} variant={ButtonVariant.White} href={getCoursesListingPath(tenant)}>
				<Formatted text={translate("coursesMore")} />
			</Link>
		{/snippet}
	</HandwrittenBanner>
	<HandwrittenBanner
		topAligned
		title={translate("fathersFamily")}
		tagline={translate("fathersFamilyBenefits")}
		lettering={{ src: fathersFamilyLogo, width: 320, height: 221 }}
		sources={{
			default: heroImageXs,
			">sm": heroImageSm,
			">md": heroImageMd,
			">lg": heroImageLg,
			">xl": heroImageXl,
			">2xl": heroImage2Xl,
			">3xl": heroImage3Xl,
		}}
	>
		{#snippet actions()}
			<Link size={ButtonSize.Medium} variant={ButtonVariant.White} href={getMembershipPagePath(tenant)}>
				<Formatted text={translate("fathersFamilyMore")} />
			</Link>
		{/snippet}
	</HandwrittenBanner>
</div>
